import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { CountryService } from '../../services/country.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { ValidationService } from '../../services/validation.service';
import { DropdownService } from '../../services/dropdown.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-country-list-page',
  standalone: true,
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent, DropdownUploadButtonComponent],
  templateUrl: './country-list-page.component.html',
  styleUrl: './country-list-page.component.css',
})
export class CountryListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Country';
  show_menu = false;
  form: FormGroup;
  params: any = {};
  selected_item: any = {}
  items: any[] = [];
  isSubmitting = false;

  country_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'name', headerName: 'Country Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Country Code', filter: true, flex: 1, valueFormatter: (params: any) => params.value ? '+' + params.value : '' },
    { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 210, minWidth: 210, maxWidth: 210 }
  ];
  bulk_columns = [
    { column_name: 'Country Name', type: 'text', return_as: 'name', sample_value: 'India', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.location_name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Country Code', type: 'text', return_as: 'code', sample_value: '91', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: /^[0-9]+$/ },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_location_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this) })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.masters_location_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public cs: CountryService, public ar: ActivatedRoute, public vs: ValidationService, public ds: DropdownService) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      is_active: [true]
    });
  }
  ngOnInit(): void {
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      console.log(this.params, 'params');
      await this.get_list(this.params);
    })

  }
  async get_list(filter?: any) {
    try {
      const res = await this.cs.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async delete(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_disabled_modal?.open();
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.cs.update(this.selected_item.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('country');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable_country() {
    try {
      let res = await this.cs.delete(this.selected_item.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_item = {};
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('country');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.cs.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.ds.invalidate_dropdown_cache('country');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async open_form_modal(item?: any) {
    this.selected_item = item || {};
    if (this.selected_item && this.selected_item.id) {
      let response = await this.cs.get(item.id);
      this.selected_item = { ...response.data };
      this.form.patchValue({ ...this.selected_item, });
    } else {
      this.selected_item = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  open_view_modal(item: any) {
    console.log(item);
    this.selected_item = item || {};
    this.view_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit_country() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_item && this.selected_item.id) {
        let update_response = await this.cs.update(this.selected_item.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.cs.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('country');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.cs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

}
